import React from "react";
import { Text, View } from "native-base";
import { ShoppingCart } from "lucide-react-native";
import { webFont } from "../../../Universal/API/API";
import PressableWrapp from "../../../Universal/Buttons/PressableReact/PressableWrapp";
import { formatCurrency } from "../../helpers";
import { webCursorPointer } from "./helpers";

type CurrentOrderCardProps = {
  scaleAll: number;
  isHistoryMode: boolean;
  currentOrderQuantity: number;
  currentOrderItemsCount: number;
  currentOrderTotal: number;
  onPress: () => void;
};

const CurrentOrderCard: React.FC<CurrentOrderCardProps> = ({
  scaleAll,
  isHistoryMode,
  currentOrderQuantity,
  currentOrderItemsCount,
  currentOrderTotal,
  onPress,
}) => {
  return (
    <PressableWrapp
      onPress={onPress}
      style={[
        {
          borderRadius: 18 * scaleAll,
          backgroundColor: isHistoryMode ? "#FFFFFF" : "#111111",
          borderWidth: 1,
          borderColor: isHistoryMode ? "#ECE8E1" : "#111111",
          padding: 14 * scaleAll,
          marginBottom: 10 * scaleAll,
        },
        webCursorPointer,
      ]}
    >
      <View style={{ flexDirection: "row", alignItems: "center" }}>
        <View
          style={{
            width: 34 * scaleAll,
            height: 34 * scaleAll,
            borderRadius: 12 * scaleAll,
            backgroundColor: isHistoryMode ? "#F7F5F0" : "rgba(255,255,255,0.14)",
            alignItems: "center",
            justifyContent: "center",
            marginRight: 10 * scaleAll,
          }}
        >
          <ShoppingCart size={18 * scaleAll} color={isHistoryMode ? "#111111" : "#FFFFFF"} />
        </View>
        <View style={{ flex: 1, minWidth: 0, paddingRight: 8 * scaleAll }}>
          <Text
            selectable={false}
            style={{
              fontFamily: webFont("Inter"),
              fontSize: 12 * scaleAll,
              color: isHistoryMode ? "#111111" : "#FFFFFF",
              fontWeight: "700",
            }}
          >
            Текущий заказ
          </Text>
          <Text
            selectable={false}
            style={{
              fontFamily: webFont("Inter"),
              fontSize: 11 * scaleAll,
              color: isHistoryMode ? "#7A746C" : "rgba(255,255,255,0.72)",
              fontWeight: "600",
              marginTop: 2 * scaleAll,
            }}
          >
            {currentOrderQuantity} шт. • {currentOrderItemsCount} поз.
          </Text>
        </View>
        <Text
          selectable={false}
          style={{
            fontFamily: webFont("Inter"),
            fontSize: 18 * scaleAll,
            color: isHistoryMode ? "#111111" : "#FFFFFF",
            fontWeight: "700",
          }}
        >
          {formatCurrency(currentOrderTotal)} ₽
        </Text>
      </View>
    </PressableWrapp>
  );
};

export default React.memo(CurrentOrderCard);
